<template>
<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
<div class="collabsable-section">
    <div class="section-title clickable-header" @click="toggleExpanded()">
        <div class="model-3d"></div>
        <div style="flex-grow: 1;font-size: 17px;">Projects</div>
        <div style="color: gray;" :class="['expand-collapse-ico','fas',!isExpanded?'fa-caret-down':'fa-caret-up']"></div>
    </div>
    <div v-if="isExpanded" class="expanded-section">
        <div style="text-align: end;padding: 3px 10px;">
            <input type="text" v-virtual-keyboard v-model="searchtext" style="width: 25%;" placeholder="Search..." />
        </div>
        <SelectionInfo :selected_items="selected_items" @delete-selection="deleteSelectedItems()" @clear-selection="onClearSelection"></SelectionInfo>
        <div v-for="project in shownProjects" :key="project.id">
            <div class="model-row" @click="project.isExpanded=!project.isExpanded">
                <div style="color: gray;" :class="['expand-collapse-ico','fas',!project.isExpanded?'fa-caret-down':'fa-caret-up']"></div>
                <b style="padding-left: 5px;flex-grow:1;">{{project.name}}</b>

                <div class="btn-hover-orange fas fa-pen" @click.stop="editProject(project)" title="Edit Project"></div>
                <div class="btn-hover-orange fas fa-trash" @click.stop="deleteProject(project)" title="Delete Project"></div>
            </div>
            <progress style="width: 100%;height: 20px;" v-if="project.isUploading"></progress>

            <div v-if="project.isExpanded && project.images && project.images.length > 0" style="padding-left: 5px;display: flex;overflow-x: auto;">
                <AdminImage360Row v-for="image in project.images"
                                    :key="image.id"
                                    style="width: 300px;" 
                                    @on-selection-changed="updateSelectedItems" 
                                    @change-image-elevation="changeImageElevation(project, image, ...arguments)"
                                    :image="image" 
                                    :project="project">
                </AdminImage360Row>
            </div>
        </div>
        <div class="info-section" style="align-items: center;flex-direction: row;">
            <div class="admin-btn" style="width: 150px;margin-right: 7px;" @click="addProject()">Add Project</div>
            <div class="admin-btn" style="margin-right: 7px;width:200px;" @click="showUploadImagesUI()">Upload Images 360</div>
        </div>
    </div>
</div>
</template>

<script>
import { toggleExpandComponent } from '../../../scripts/js/forgeviewer'
import { ForgeProject } from '../../../scripts/js/forgeModels'
import { saveProjects, editType } from '../../../utils/mongoUtils'
import $ from 'jquery'

export default {
    name: 'AdminProjects',
    components: {
        'SelectionInfo': () => import('../../common/selectionInfo.vue'),
        'AdminImage360Row': () => import('./adminImage360Row.vue'),
    },
    data() {
        return {
            isExpanded: false,
            searchtext: '',
            isTranslating: false,
            selected_items: this.$store.state.projects.flatMap(o => o.images).filter(o => o.isSelected),
        }
    },
    props: ['projects', 'assetid'],
    methods: {
        onClearSelection() {
            this.selected_items.forEach(o => o.isSelected = false);
            this.selected_items.splice(0, this.selected_items.length);
        },
        toggleExpanded() {
            toggleExpandComponent(this);
        },
        deleteProject(project) {
            this.$store.dispatch({
                type: "confirm_Forge",
                message: 'Are you sure you want to delete project?', callback: () => {
                    saveProjects(project, editType.DELETE_Project);
                    var index = this.projects.findIndex(o => o == project);
                    let currentProjects = this.projects.slice(0, index).concat(this.projects.slice(index + 1));
                    this.$emit('update_projects', currentProjects);
                }
            })
        },
        addProject() {
            this.$store.dispatch({
                type: "prompt_Forge",
                title: "Add Project Name",
                callback: name => {
                    name = name.trim();
                    if (!name) {
                        this.$store.dispatch({
                            type: "alert_Forge",
                            message: 'Invalid Name.'
                        });
                        return;
                    }
                    if (this.projects.some(o => o.name == name)) {
                        this.$store.dispatch({
                            type: "alert_Forge",
                            message: 'Name is alreay existing, please choose another name.'
                        });
                        return;
                    }
                    var proj = new ForgeProject();
                    proj.name = name;
                    this.$emit('update_projects', [...this.projects, proj])
                    saveProjects(proj, editType.CREATE_Project);
                },
                input: {
                    inputName: "Name",
                    inputValue: ""
                }
            })
        },
        editProject(project) {
            this.$store.dispatch({
                type: "prompt_Forge",
                title: "Edit Project Name",
                callback: name => {
                    name = name.trim();
                    if (!name) {
                        this.$store.dispatch({
                            type: "alert_Forge",
                            message: 'Invalid Name.'
                        });
                        return;
                    }
                    if (this.projects.some(o => o.id != project.id && o.name == name)) {
                        this.$store.dispatch({
                            type: "alert_Forge",
                            message: 'Name is alreay existing in another project, please choose another name.'
                        });
                        return;
                    }
                    project.name = name;
                    saveProjects(project, editType.EDIT_Project);
                },
                input: {
                    inputName: "Name",
                    inputValue: project.name
                }
            })
        },
        showUploadImagesUI() {
            if (this.$store.state.projects.length == 0) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Please add project first.'
                })
                return;
            }
            $('#uploadImagesModal').css('display', 'flex');
        },
        deleteSelectedItems() {
            this.$store.dispatch({
                type: "confirm_Forge",
                message: 'Are you sure you want to delete selected image/s?', callback: () => {
                    saveProjects(this.selected_items, editType.DELETE_IMAGES360);
                    this.selected_items.forEach(img => {
                        var targetProject = this.$store.state.projects.find(o => o.images.includes(img));
                        var index = targetProject.images.findIndex(o => o == img);
                        targetProject.images.splice(index, 1);
                    })
                    this.selected_items = [];
                }
            })
        },
        updateSelectedItems() {
            this.selected_items = this.shownProjects.flatMap(o => o.images).filter(o => o.isSelected);
        },
        changeImageElevation(project, image, elevation) {
            image.forgeCameraPosition.z = elevation;
            saveProjects(image, editType.EDIT_IMAGE360, project.name);
        },
    },
    computed: {
        shownProjects: function () {
            return this.$store.state.forgeService.filterLevelsBySearch(this.projects, this.searchtext);
        },
    },
}
</script>

<style>
.model-3d {
    background-size: cover;
    background-image: url(../../../images/3d-black.png);
    width: 23px;
    height: 23px;
    margin-right: 10px;
}
</style>
